import React from "react";
import { motion } from "framer-motion";
import {
    FiChevronLeft,
    FiChevronRight,
    FiCalendar,
    FiRefreshCw
} from "react-icons/fi";

import dayjs from "dayjs";

import "../styles/attendance-header.css";

export default function AttendanceHeader({

    currentDate,

    onPreviousMonth,

    onNextMonth,

    onToday,

    onRefresh,

    loading

}) {

    return (

        <motion.div

            className="attendance-header"

            initial={{ opacity: 0, y: -30 }}

            animate={{ opacity: 1, y: 0 }}

            transition={{ duration: .5 }}

        >

            <div className="attendance-header-left">

                <div className="attendance-icon">

                    <FiCalendar />

                </div>

                <div>

                    <h1>

                        Attendance Calendar

                    </h1>

                    <p  style={{color:"white"}}>

                        View your attendance history and session records.

                    </p>

                </div>

            </div>

            <div className="attendance-header-right">

                <button

                    className="attendance-btn"

                    onClick={onPreviousMonth}

                >

                    <FiChevronLeft />

                </button>

                <button

                    className="attendance-today"

                    onClick={onToday}

                >

                    Today

                </button>

                <button

                    className="attendance-btn"

                    onClick={onNextMonth}

                >

                    <FiChevronRight />

                </button>

                <div className="attendance-month">

                    <h3>

                        {dayjs(currentDate).format("MMMM YYYY")}

                    </h3>

                    {/* <span>

                        {dayjs().format("dddd, DD MMMM YYYY")}

                    </span> */}

                </div>

                <button

                    className="attendance-refresh"

                    onClick={onRefresh}

                    disabled={loading}

                >

                    <FiRefreshCw

                        className={loading ? "spin" : ""}

                    />

                    Refresh

                </button>

            </div>

        </motion.div>

    );

}